// Variable declaration
var allStores = [];
var listOfRestrictedStores  = [6120,6909, 6901, 6709, 6864, 6111, 6918, 6825, 6215, 6478, 6430, 6923, 6868,
  6869, 6861, 6301, 6606, 6711, 6860, 6303, 6706, 6854, 6127, 6859, 6413, 6464,
  6505, 6930, 6448, 6832, 6707, 6821, 6426, 6967, 6974, 6806, 6811, 6921, 6907,
  6965, 6603, 6411, 6960, 6422, 6917, 6870, 6438, 6440, 6416, 6434, 6484, 6205,
  6425, 6414, 6906, 6940, 6703, 6409, 6107, 6957, 6414, 6906, 6940, 6703, 6409,
  6107, 6957, 6828, 6476, 6311, 6602, 6865, 6437, 6443, 6468, 6919, 6123, 6605,
  6421, 6471, 6445, 6452, 6475, 6932, 6404, 6407, 6109, 6506, 6804, 6943, 6307,
  6515, 6406, 6412, 6122, 6862, 6810, 6455, 6951, 6985, 6403, 6402, 6946, 6433,
  6410, 6846, 6135, 6826, 6302, 6609, 6959, 6420, 6453, 6853, 6942, 6428, 6463,
  6831, 6993, 6419, 6481, 6914, 6472, 6106, 6980, 6812, 6447, 6101, 6871, 6902,
  6418, 6124, 6460, 6431, 6823, 6944, 6469, 6845, 6705, 6105, 6432, 6405, 6803,
  6477, 6508, 6470, 6905, 6931, 6429, 6503, 6507, 6473, 6427, 6400, 6934, 6102,
  6835, 6814, 6401, 6712, 6924, 6872, 6937, 6104, 6465, 6310, 6230, 6454, 6417,
  6408, 6708, 6956, 6113, 6304, 6713, 6312, 6856, 6987, 6841, 6966, 6829, 6928,
  6714, 6866, 6132, 6903
];
var VIS_STORE_CONFIG = window.vis;
//Check if VIS/Store Config defined..
if(typeof VIS_STORE_CONFIG != undefined && VIS_STORE_CONFIG != null && typeof  VIS_STORE_CONFIG.globalConfig != undefined && VIS_STORE_CONFIG.globalConfig != null){
  var maxDistanceTofind = VIS_STORE_CONFIG.globalConfig.store_radius;
  var googleApiKey = VIS_STORE_CONFIG.globalConfig.google_api_key;
  // Check if Store API Endpoint defined with global settings
  if(typeof  VIS_STORE_CONFIG.globalConfig.storeAPIendPointURL != undefined && VIS_STORE_CONFIG.globalConfig.storeAPIendPointURL != null){
  	/*var storeAPIendPointURL = VIS_STORE_CONFIG.globalConfig.storeAPIendPointURL;*/
    var storeAPIendPointURL = "https://as-handt-store-address-service.azurewebsites.net/api/AllStoreData";
  }else{
    // Set default Store API Endpoint
  	console.log('Kindly define Store API Endpoint..')
  }
}else{
  // Set Default Values, if settings not defined globally.
  var maxDistanceTofind = 20; //Miles Default Value
}


// VIS START HERE
$(function() {
  var errorMsgEle = $('.store-error-msg');
  var visLoader = $('[data-ele="vis-loader"]');
  var userInputConatiner = $('[data-ele="user-input-container"]');
  var postCodeInput = $('[data-name="postcode"]');
  var storeDropdownListEle = $('[data-id="stores-dropdown-list"]');  
  var visFormTemplateEle = document.getElementById("visFormTemplate");
  
  if(typeof visFormTemplateEle != undefined && visFormTemplateEle != null){
    // Compile the VIS Form Template and store it in variable
    var visFormTemplateSource = visFormTemplateEle.innerHTML;
    visFormTemplate = Handlebars.compile(visFormTemplateSource);
  }

  allStoreData();
  
  function allStoreData(){
    console.log("allStoreData()")
    showVisLoader();
    url = storeAPIendPointURL;
    $.ajax({
      url: url,
      type: 'GET',
      dataType: 'json',
      success: function (results) {
        if(results){
          hideVisLoader();
        }
      }
    });
  }
  
  function initStoresList(enableLoader) {
    if(enableLoader==true){
    	showVisLoader();
    }
    // Template definition
    var storeListTemplateEle = document.getElementById("storeListTemplate");
    // If page is store locator only then template should be compliled
    if(typeof storeListTemplateEle != undefined && storeListTemplateEle != null){
      // Compile the store template and store it in variable
      var storeListTemplateSource = storeListTemplateEle.innerHTML;
      storeListTemplate = Handlebars.compile(storeListTemplateSource);
    }
    // Get store information from storeAPIendPointURL by making GET request
    $.ajax({
      url: storeAPIendPointURL,
      type: 'GET',
      dataType: 'json',
      success: function (response) {
        if(response){
          hideVisLoader();
          response.sort(function(a, b){
            var aName=a.storeName.trim().toLowerCase(), bName=b.storeName.trim().toLowerCase();
            if (aName < bName){
              return -1 
            }
            if (aName > bName){
              return 1
            }
            return 0 //default return value (no sorting)
          })
        allStores = response.filter(store => !listOfRestrictedStores.includes(store.storeNumber));
        }
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) { 
        console.log(`Status: ${textStatus}, Sorry, we are unable to fetch store information from server, please try again later`);
      } 
    });
  }
  
  // Load store list from API and store to local Memory
  initStoresList();
  
  // Calculate radians
  function radians(degrees) {
    var TAU = 2 * Math.PI;
    return degrees * TAU / 360;
  }
  
  $(document).on('click', '[data-ele="change-store"]', function(){
    $('[data-ele="vis-form-section"]').html('');
    $('[data-ele="user-store-input-container"]').show();
  });
  
  $(document).on('click', '.open-vis-deposit', function(){
    if($('#vis-c-telephone').val() != ''){
      $('.vis-deposit-container').show();
      $('.vis-deposit-message').html('');
    }
  });
  $(document).on('click', '.cancel-deposit', function(){
    $('.vis-deposit-container').hide();
    hideVisLoader();
    
  });
  
  $(document).on('click', '.add-deposit', function(event) {
    $(this).val('Processing...');
    $(this).attr('disabled','disabled');
    $('.cancel-deposit').attr('disabled','disabled'); 
    visGetAllRequestByCustomerId(1, 2)
    //checkCartHasVIS();  
    //$('[data-ele="vis-form"]').trigger('submit');  
  })
  
  $(document).on('keypress', '[data-ele="vis-c-telephone"]',  function (event) {
    var regex = new RegExp(/^\d*\.?\d*$/)
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    }
  });  
  
  // Calculate distance between store and user address
  function calculateDistance (storeLat, userAddressLat, storeLng, userAddressLng ) {
    var earthRadius = 3958.75;
    var latDiff = radians(userAddressLat-storeLat);
    var lngDiff = radians(userAddressLng-storeLng);
    var a = Math.sin(latDiff /2) * Math.sin(latDiff /2) +
        Math.cos(radians(storeLat)) * Math.cos(radians(userAddressLat)) *
        Math.sin(lngDiff /2) * Math.sin(lngDiff /2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    var distance = earthRadius * c;
    return distance;
  }
  
  function showVisLoader(){
  	visLoader.removeClass('hide');
  }
  
  function hideVisLoader(){
  	visLoader.addClass('hide');
  }
  
  postCodeInput.keyup(function(event) {
    $('.store-error-msg').addClass('hide');
    if (event.keyCode === 13) {
      var postCode = postCodeInput.val();
      getUserAdddressDetails(postCode);
    }
  });
  
  $('[data-ele="postcode-submit-btn btn"]').click(function(event) {
    var postCode = postCodeInput.val();
    getUserAdddressDetails(postCode);
  });
  
  storeDropdownListEle.on('change', function(event) {
    var _this = $(this);
    var postCode = _this.val();
    var address = _this.find('option:selected').text().trim();
    if(typeof postCode != 'undefined' && postCode != null && postCode != ''){
    	getNearestStoreToUserAddress(postCode, false, address);
    }
  });
  
  $('[data-ele="toggle-user-input"]').on('click', function(){
    if(typeof allStores.length < 0){
      initStoresList(true);
      changeUserInputType();
    }else{
      changeUserInputType();
    }
  });

  function changeUserInputType(){ 
 	userInputConatiner.toggleClass('hide');
    errorMsgEle.addClass('hide');
    $('[data-ele="vis-no-store"]').remove();
    
    //Dropdown data populated first time, when user clicks on toogle toggle-user-input.
    var dropdownLoaded = storeDropdownListEle.attr('data-loaded');
    if((typeof dropdownLoaded == undefined || typeof dropdownLoaded == 'undefined') && (typeof allStores != undefined && allStores.length > 0)){
      $(allStores).each(function() {
        var _this = this;
        var storeName = _this.storeName.trim();
        var storeAddress = _this.storeAddress.trim();
        var storeArea = _this.storeArea.trim();
        var storePostcode = _this.storePostcode.trim();
        var optionTxt = storeName +' ('+storeAddress+', '+storePostcode+')';
    	storeDropdownListEle.append($("<option>").attr('value',_this.storeNumber).text(optionTxt));
      });
      storeDropdownListEle.attr('data-loaded', 'true');
    }
  };
  
  function formHelperParseForm($form){
    var serialized = $form.serializeArray();
    var s = '';
    var data = {};
    for(s in serialized){
      data[serialized[s]['name']] = serialized[s]['value']
    }
    return JSON.stringify(data);
  }
  
  $(document).on("submit", '[data-ele="vis-form"]', function(event){
    var _this = $(this);
    _this.find('input[type="submit"]').prop('disabled', true);
    jQuery('[data-ele="vis-req-message-section"]').remove();
    var postUrl = VIS_STORE_CONFIG.globalConfig.visRequestCreateEndPoint;
    event.preventDefault();
    var formData = formHelperParseForm($(this));
    showVisLoader();
    
    $.ajax({
      headers: { 
        customerId : VIS_STORE_CONFIG.globalConfig.customerId,
        keyTimestamp : VIS_STORE_CONFIG.globalConfig.keyTimestamp,
        hashValue : VIS_STORE_CONFIG.globalConfig.hashValue
      },
      type : 'POST', // define the type of HTTP verb we want to use (POST for our form)
      url : postUrl, // the url where we want to POST
      data : formData, // our data object
      contentType: "application/json",
      success: function (data) {        
        console.log('VIS Create request success');
        if(data){
          var soldOutText = 'Reserved'; //theme.strings.soldOut;
          if(data && typeof data.didError != 'undefined' && data.didError == false && data.message=='success'){
            var message = '<span class="vis-req-message success-message">Thank you for your request to view this item in your local store We will let you know as soon as the item has arrived for you to view. If you have any questions, please don\'t hesitate to contact us on <a href="tel:+08001690780">0203 551 1259</a> or <a href="mailto:shoponline@handt.co.uk">shoponline@handt.co.uk</a>. Alternatively, you can visit <a target="_blank" href="/account#my_vis">My Account</a> section to view details.</span>';
            $('[data-ele="vis-form-section"]').remove();
            $('.custom-btn .view-in-store, .product-form__cart-submit').addClass('btn').attr('aria-disabled', true);
            $('.product-form__cart-submit').find('span[data-add-to-cart-text]').text(soldOutText);
            $('.product-single__meta .in-stock').addClass('out-of-stock').hide();
            $('.product-single__meta .price__badges').find('.price__badge--sold-out').html('<span class="text-reserved">'+soldOutText+'</span>');
            $('.product-single__meta .price__badges').find('.price__badge--sold-out').show();
            $('.product-form.product-form-product-template .product-form__cart-submit, .product-form.product-form-product-template .custom-btn').hide();
            $('.product-form.product-form-product-template').css(
              {"border-top": "0px", "padding-top": "0px"}
            );
            visDeposit()
          }else{
            console.log('VIS Create request unsuccessfull');
            var message = '<span class="vis-req-message error-message">Sorry, we are unable to submit <b>View In Store</b> request, please try again later.</span>';
            $('.vis-deposit-message').html(message);
            $('.vis-deposit-inner .add-deposit').val('Pay Deposit');  
            $('.vis-deposit-inner .button').removeAttr('disabled');
            $('.add-deposit').removeAttr('disabled');
            $('.cancel-deposit').removeAttr('disabled'); 
          }

          $('[data-ele="vis-form-container"]').append('<div data-ele="vis-req-message-section" class="vis-req-message-section">'+message+'</span>');
          _this.find('input[type="submit"]').prop('disabled', false);
          hideVisLoader();
        }
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        _this.find('input[type="submit"]').prop('disabled', false);
        var message = '<span class="vis-req-message error-message">Sorry, we are unable to submit <b>View In Store</b> request, please try again later.</span>';
        $('[data-ele="vis-form-container"]').append('<div data-ele="vis-req-message-section" class="vis-req-message-section">'+message+'</span>');

        //vis deposit

        
        $('.vis-deposit-message').html(message);
        $('.vis-deposit-inner .add-deposit').val('Pay Deposit');  
        $('.vis-deposit-inner .button').removeAttr('disabled');
        $('.add-deposit').removeAttr('disabled');
        $('.cancel-deposit').removeAttr('disabled');
        
        hideVisLoader();
      } 
    });
  })
  
  function getNearestStoreToUserAddress(userSelectedStore, locationLatLng, address){
    $('[data-ele="vis-no-store"]').remove();
    var newVISData = [];
    if(typeof allStores != undefined && allStores.length > 0){
      $(allStores).each(function() {
        var _this = this;
        _this.location = address;
        if(typeof userSelectedStore == undefined || userSelectedStore == false){
          storeLat = _this.storeLatitude;
          storeLng = _this.storeLongitude;
          userAddressLat = locationLatLng.lat;
          userAddressLng = locationLatLng.lng;
          var distance = calculateDistance(storeLat, userAddressLat, storeLng, userAddressLng);
          _this.distance = parseFloat(distance).toFixed(2);
          if(maxDistanceTofind > parseInt(distance)){
          	newVISData.push(_this);	
          }
        }else{
          if(userSelectedStore == _this.storeNumber){
            var distance = 0;
            _this.distance = parseFloat(distance).toFixed(2);
          	newVISData.push(_this);
          }
        }
      });
      
      if(typeof newVISData != undefined && newVISData.length > 0){
        newVISData.sort(function(a, b) {
          return a.distance - b.distance;
        });
        var nearestStore = newVISData[0];
        generateVISForm(nearestStore);
      }else{
      	$('[data-ele="user-store-input-container"]').append('<span data-ele="vis-no-store" class="vis-no-store no-store-result">Sorry, no stores found within '+maxDistanceTofind+' miles.</span>');
      }
    }
  }
  
  function getUserAdddressDetails(address) {
    if (address != "") {
      showVisLoader();
      url = 'https://maps.googleapis.com/maps/api/geocode/json?address='+address+',+UK&key='+googleApiKey;
      $.ajax({
        url: url,
        type: 'GET',
        dataType: 'json',
        success: function (results) {
          if(results){
            hideVisLoader();
            results = results.results;
            var locationLatLng = results[0].geometry.location;
            getNearestStoreToUserAddress(false, locationLatLng, address);
            hideVisLoader();
          }
        }
      });
    }else{
    	errorMsgEle.removeClass('hide');
    }
  }
  
  function generateVISForm(nearestStore){
    if(typeof nearestStore != undefined && nearestStore != null){
      if(typeof VIS_STORE_CONFIG != undefined && VIS_STORE_CONFIG != null && typeof  VIS_STORE_CONFIG.proConfig != undefined && VIS_STORE_CONFIG.proConfig != null){
        var proConfig = VIS_STORE_CONFIG.proConfig;
        nearestStore.productId = proConfig.productId;
        nearestStore.customerId = proConfig.customerId;
        nearestStore.productBarCode = proConfig.productBarCode;
        nearestStore.cusEmail = proConfig.customerEmail;
        nearestStore.cusName = proConfig.customerName;
        nearestStore.storeNumberInt = parseInt(nearestStore.storeNumber);
      }
      if(typeof visFormTemplate != undefined && visFormTemplate != null){
        $('[data-ele="vis-form-section"]').html(visFormTemplate(nearestStore));
      }
      $('[data-ele="user-store-input-container"]').hide();
    }
  }

  //get VIS status done by user  
  function visGetAllRequestByCustomerId(pageNumber, pageSize){
    if(typeof pageNumber == undefined || typeof pageNumber == 'undefined' || pageNumber == null){
    	pageNumber = 1;
    }else{
    	pageNumber = parseInt(pageNumber);
    }
    
    if(typeof pageSize == undefined || typeof pageSize == 'undefined' || pageSize == null){
    	pageSize = 2;
    }else{
    	pageSize = parseInt(pageSize);
    }
    
    
    if(typeof VIS_STORE_CONFIG != undefined && VIS_STORE_CONFIG != null && typeof  VIS_STORE_CONFIG.globalConfig != undefined && VIS_STORE_CONFIG.globalConfig != null){
      var apiEndPoint = VIS_STORE_CONFIG.globalConfig.visGetAllRequestByCustomerId;
     // var apiEndPoint = VIS_STORE_CONFIG.globalConfig.visGetAllRequest;
      var customerId = VIS_STORE_CONFIG.globalConfig.customerId;
    }else{
    	return false;
    }
    var settings = {
      headers: { 
        customerId : VIS_STORE_CONFIG.globalConfig.customerId,
        keyTimestamp : VIS_STORE_CONFIG.globalConfig.keyTimestamp,
        hashValue : VIS_STORE_CONFIG.globalConfig.hashValue
      },
      "url": apiEndPoint+'?pageNumber='+pageNumber+'&pageSize='+pageSize+'&customerId='+customerId,
      //"url": apiEndPoint+'?pageNumber='+pageNumber+'&pageSize='+pageSize,
      "method": "GET",
      "timeout": 0
    };

    $.ajax(settings)
    .done(function (response) {
      if(response){
        callbackVisRequestList(response)
      }
    })
    .fail(function (jqXHR, textStatus, errorThrown) {
      var message = '<span class="vis-req-message error-message">Please reload the page.</span>';
      $('.vis-deposit-message').html(message);
      $('.vis-deposit-inner .add-deposit').val('Pay Deposit');  
      $('.vis-deposit-inner button').removeAttr('disabled');
      setTimeout(function(){
        $('.vis-req-message.error-message').fadeOut();
      },7000)
      console.log(`Status: ${textStatus}, Sorry, we are unable to fetch VIS information from server, please try again later`);
      alert()
      $('.add-deposit').removeAttr('disabled');
      $('.cancel-deposit').removeAttr('disabled');
    });
  };
  
  function callbackVisRequestList(response){
    /*if(typeof response == 'undefined' || typeof response == undefined || response == null){return false;}*/    
    var visRequestData = response.requestdata;
    var storeData = response.storeData;  
    if(visRequestData.didError == false){
      if(visRequestData.itemsCount >= 0){
        generateListHtml(visRequestData, storeData);
      }else{
        $('[data-ele="vis-request-list"]').append("<p>You haven't placed a <b>View In Store</b> request yet. Please browse for a qualifiying items to view in your local store for free.</p>");
      }
    }
  }
  
  function generateListHtml(response, storeData){
    /*if(typeof response == 'undefined' || typeof response == undefined || response == null){return false;}*/
    if(response.model.length >= 0){
      var requestCollection = response.model;
      var requestedVISArr = [];
      $(requestCollection).each(function() {
        var _this = this;
        requestedVISArr.push(_this.requestStatus);
      })

      //var restricUser = ["Requested","Approved","InTransit", "Arrived"];
      var allowUser = ["Manually_Closed", "CustomerCancelled", "Sold", "Rejected", "Expired"];
      var found = allowUser.some(r=> requestedVISArr.includes(r));
      if(response.model.length < 2){
        //alert("length is 0")
        found = true
      }
      if(found){
        //alert("2 vis found and allow user")
        checkCartHasVIS();
      }
      else{
        //alert("Vis found and not allowed to do")
        var message = '<span class="vis-req-message error-message">There is a maximum of 2 View in Store requests allowed at any one time. <b><u><a href="https://handt.co.uk/pages/terms-and-conditions">Please see our full T&CS for full details</a></u></b></span>';
        $('.vis-deposit-message').html(message);
        $('.vis-deposit-inner .add-deposit').val('Pay Deposit');  
        $('.vis-deposit-inner button').removeAttr('disabled');
        setTimeout(function(){
          $('.vis-req-message.error-message').fadeOut();
        },10000)          
      }
    }
  }

  function visDeposit(){    
    /*var title = $('.product__title').text();
    var price = $('.price-item.price-item--regular').text();
    data: { "id":42353032659081, "quantity":1 , "properties":[{"Title ": title }, {"Price ": price }]},*/
    console.log('visDeposit initiated');
    var deposit = $('.vis-form-wrapper').attr('data-visdeposit');
    if(deposit == 'true'){
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $('#form-vis-deposit').serialize(),
        dataType: 'json',
        success: function() {
          setTimeout(function(){
            location.href = '/cart';
          },1000)
        },
        error: function(err) {
          alert(err.responseJSON.description)
          // Do something on error (e.g. show an error message)
        }
      });
    }
  }
  
  function checkCartHasVIS(){
    var itemCount = $('cart-drawer-items .cart-items tr[data-id="49114017693969"]').length;
    if(itemCount > 1){
      console.log('count 2')
      var message = '<span class="vis-req-message error-message">Sorry, you are only allowed to request 2 active View in Store.</span>';
      $('.vis-deposit-message').html(message);
      $('.vis-deposit-inner .add-deposit').val('Pay Deposit');  
      $('.vis-deposit-inner button').removeAttr('disabled');
      setTimeout(function(){
        $('.vis-req-message.error-message').fadeOut();
      },7000)
    }else{
      //visDeposit()
      $('[data-ele="vis-form"]').trigger('submit');       
    }
  }
});

